module.exports = __webpack_public_path__ + "static/media/backgroundSmall.ce867ab1.jpg";